module.exports = __webpack_public_path__ + "img/2.aa86b422.png";